export default __webpack_public_path__ + "static/press-awards-hartford-a28ed2306dd334c5d8fe6341805c9093.png";